/**
 * @generated SignedSource<<10e0af71988bae21ce20c76db91e5104>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InstructorLessonTypeSelectQuery$variables = {
  facilitySlug: string;
  instructorId: string;
  membershipTypeId?: string | null | undefined;
};
export type InstructorLessonTypeSelectQuery$data = {
  readonly facility: {
    readonly " $fragmentSpreads": FragmentRefs<"LessonTypeSelect_facility">;
  } | null | undefined;
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"LessonTypeSelect_staffProfile">;
  } | null | undefined;
};
export type InstructorLessonTypeSelectQuery = {
  response: InstructorLessonTypeSelectQuery$data;
  variables: InstructorLessonTypeSelectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "facilitySlug"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "instructorId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "membershipTypeId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "instructorId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "facilitySlug"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "showPrices",
    "storageKey": null
  },
  (v6/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "InstructorLessonTypeSelectQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LessonTypeSelect_staffProfile"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Facility",
        "kind": "LinkedField",
        "name": "facility",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LessonTypeSelect_facility"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "InstructorLessonTypeSelectQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "facilitySlug",
                    "variableName": "facilitySlug"
                  }
                ],
                "concreteType": "LessonTypeConnection",
                "kind": "LinkedField",
                "name": "lessonTypes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LessonTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LessonType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": "lessonTypeRates",
                            "args": null,
                            "concreteType": "LessonRateConnection",
                            "kind": "LinkedField",
                            "name": "rates",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LessonRateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LessonRate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "allMembershipTypes",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ClientTypeConnection",
                                        "kind": "LinkedField",
                                        "name": "membershipTypes",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ClientTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v5/*: any*/),
                                                  (v6/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "archivedAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "description",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "defaultDurationMins",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "visibleToMembers",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "instructorId",
                                "variableName": "instructorId"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "durations",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "items": [
                                  {
                                    "kind": "Variable",
                                    "name": "instructorIds.0",
                                    "variableName": "instructorId"
                                  }
                                ],
                                "kind": "ListValue",
                                "name": "instructorIds"
                              },
                              {
                                "kind": "Variable",
                                "name": "membershipTypeId",
                                "variableName": "membershipTypeId"
                              }
                            ],
                            "concreteType": "LessonRateConnection",
                            "kind": "LinkedField",
                            "name": "rates",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LessonRateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LessonRate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ChargeRuleSetConnection",
                                        "kind": "LinkedField",
                                        "name": "chargeRuleSets",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ChargeRuleSetEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ChargeRuleSet",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ChargeRuleConnection",
                                                    "kind": "LinkedField",
                                                    "name": "chargeRules",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "ChargeRuleEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ChargeRule",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "duration",
                                                                "storageKey": null
                                                              },
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "price",
                                                                "storageKey": null
                                                              },
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "minPlayers",
                                                                "storageKey": null
                                                              },
                                                              (v6/*: any*/)
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v6/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "StaffProfile",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Facility",
        "kind": "LinkedField",
        "name": "facility",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Club",
            "kind": "LinkedField",
            "name": "club",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "supportsPublic",
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PublicLessonsPermissionSet",
            "kind": "LinkedField",
            "name": "publicLessonsPermissionSet",
            "plural": false,
            "selections": (v7/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PrivateLessonsPermissionSet",
            "kind": "LinkedField",
            "name": "privateLessonsPermissionSet",
            "plural": false,
            "selections": (v7/*: any*/),
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "38e7aae1be365f3b4349f1b54e2d06ff",
    "id": null,
    "metadata": {},
    "name": "InstructorLessonTypeSelectQuery",
    "operationKind": "query",
    "text": "query InstructorLessonTypeSelectQuery(\n  $instructorId: ID!\n  $membershipTypeId: ID\n  $facilitySlug: String!\n) {\n  node(id: $instructorId) {\n    __typename\n    ...LessonTypeSelect_staffProfile\n    id\n  }\n  facility(slug: $facilitySlug) {\n    ...LessonTypeSelect_facility\n    id\n  }\n}\n\nfragment LessonTypeSelect_facility on Facility {\n  ...useGetLessonTypeOptions_facility\n}\n\nfragment LessonTypeSelect_staffProfile on StaffProfile {\n  id\n  ...useGetLessonTypeOptions_staffProfile\n}\n\nfragment lessonTypeHasRateForMembershipType_lessonType on LessonType {\n  lessonTypeRates: rates {\n    edges {\n      node {\n        allMembershipTypes\n        membershipTypes {\n          edges {\n            node {\n              __typename\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment useFacilityShowLessonPrices_facility on Facility {\n  club {\n    supportsPublic\n    id\n  }\n  publicLessonsPermissionSet {\n    showPrices\n    id\n  }\n  privateLessonsPermissionSet {\n    showPrices\n    id\n  }\n}\n\nfragment useGetLessonTypeOptions_facility on Facility {\n  ...useFacilityShowLessonPrices_facility\n}\n\nfragment useGetLessonTypeOptions_staffProfile on StaffProfile {\n  lessonTypes(facilitySlug: $facilitySlug) {\n    edges {\n      node {\n        ...lessonTypeHasRateForMembershipType_lessonType\n        id\n        archivedAt\n        description\n        defaultDurationMins\n        name\n        visibleToMembers\n        durations(instructorId: $instructorId)\n        rates(membershipTypeId: $membershipTypeId, instructorIds: [$instructorId]) {\n          edges {\n            node {\n              chargeRuleSets {\n                edges {\n                  node {\n                    chargeRules {\n                      edges {\n                        node {\n                          duration\n                          price\n                          minPlayers\n                          id\n                        }\n                      }\n                    }\n                    id\n                  }\n                }\n              }\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6e3b81467f52b5c7cc0237d51e5423f8";

export default node;
